<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="semesters" :action="{'text':'add semester','url':route('academic.semester.create')}" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Semester')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Semester')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #action="data">
                    <button-link
                        v-if="hasRole('Edit Semester')"
                        :href="route('academic.semester.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'
    import {hasRole} from "../../../../Utils/checkPermission";

    export default {
        methods: {hasRole},
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['semesters'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
